import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import WardTable from "./wardTable"

const WardContainer = () => {


  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <WardTable  />
        </>
      </div>
    </div>
  )
}

export default WardContainer